export const advisorCtaThemes = {
  default: 'default',
  advisorFixContainer: 'advisorFixContainer'
};
